import { styled } from '@mui/system'

export const StatsWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

export const DownloadReportWrapper = styled('div')`
    display: flex;
    align-items: center;
    height: 26px;
    gap: 5px;
`

export const IssuesStatsLeftSection = styled('div')`
    display: flex;
    align-items: flex-start;
    gap: 18px;
`

export const IssuesStatsRightSection = styled('div')`
    display: flex;
    align-items: center;
    gap: 10px;
`
